/**
 * @module line/lineheightui
 */

import LineUI from '../lineui';

/**
 * The default lineheight UI plugin.
 *
 * It introduces the `'lineheight'` dropdown.
 *
 * @extends LineUI
 */
export default class LineHeightUI extends LineUI {

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'LineHeightUI';
	}

	constructor( editor ) {
		super( editor, 'lineheight', 'normal', 'Entre linhas', 'Espaçamento entre linhas' );
	}
}
